var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "white",
    stroke: "#1D1E26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H33C34.6569 0 36 1.34315 36 3V6H0V3Z",
    fill: "#E54322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3.55228 4 4 3.55229 4 3C4 2.44772 3.55228 2 3 2C2.44771 2 2 2.44772 2 3C2 3.55229 2.44771 4 3 4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C6.55229 4 7 3.55229 7 3C7 2.44772 6.55229 2 6 2C5.44772 2 5 2.44772 5 3C5 3.55229 5.44772 4 6 4Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4C9.55228 4 10 3.55229 10 3C10 2.44772 9.55228 2 9 2C8.44771 2 8 2.44772 8 3C8 3.55229 8.44771 4 9 4Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7322 16.4644C11.6889 16.4644 12.4644 15.6889 12.4644 14.7322C12.4644 13.7755 11.6889 13 10.7322 13C9.77554 13 9 13.7755 9 14.7322C9 15.6889 9.77554 16.4644 10.7322 16.4644Z",
    fill: "#1D1E26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3485 16.4644C26.3052 16.4644 27.0808 15.6889 27.0808 14.7322C27.0808 13.7755 26.3052 13 25.3485 13C24.3919 13 23.6163 13.7755 23.6163 14.7322C23.6163 15.6889 24.3919 16.4644 25.3485 16.4644Z",
    fill: "#1D1E26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7069 21.3805C14.117 22.1755 14.738 22.8422 15.5019 23.3076C16.2657 23.7731 17.143 24.0193 18.0375 24.0193C18.932 24.0193 19.8092 23.7731 20.5731 23.3076C21.3369 22.8422 21.9579 22.1755 22.368 21.3805",
    stroke: "#1D1E26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsIcon);
export default __webpack_public_path__ + "c2fc56b3ae525cd8fc18c6fd47ddced8.svg";
export { ForwardRef as ReactComponent };